module.exports = __webpack_public_path__ + "static/media/СЗФО_2001.e7cf3314.png";